import { useFormContext } from 'react-hook-form';
import { FormTextField } from '../../../../../../design-system/form-text-field/form-text-field';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../../../../../design-system/form/form-primitives';
import { Stack } from '../../../../../../design-system/stack/stack';
import { cn } from '../../../../../../utils/cn';

export const SalaryInformation = () => {
  const { control } = useFormContext();

  return (
    <Stack space={6} className="w-full">
      <Stack space={4} className="w-full">
        <h2 className="text-lg font-semibold text-muted-foreground">
          Salary Information <span className="text-sm text-muted-foreground">(Optional)</span>
        </h2>

        <div className="w-full">
          <FormField
            control={control}
            name="salary"
            render={({ field, formState }) => {
              return (
                <Stack space={1} align="stretch">
                  <FormItem
                    className={cn(
                      'rounded-lg border border-border bg-white px-4 py-3 focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2 focus-within:outline-hidden has-[:disabled]:cursor-not-allowed has-[:disabled]:bg-muted',
                      { 'border-destructive': !!formState.errors.salary },
                    )}
                  >
                    <Stack space={1} align="stretch">
                      <FormLabel className="text-xs font-medium text-muted-foreground">
                        Annual Pay <span className="text-inherit">(Optional)</span>
                      </FormLabel>

                      <FormControl>
                        <input
                          type="text"
                          inputMode="decimal"
                          autoComplete="off"
                          placeholder="Enter annual pay"
                          className="font-base w-full font-medium text-black placeholder:text-muted-foreground focus-visible:outline-hidden disabled:cursor-not-allowed disabled:bg-muted disabled:placeholder:text-muted-foreground/80"
                          aria-required={false}
                          {...field}
                          onChange={(e) => {
                            const raw = e.target.value;
                            let sanitized = raw.replace(/[^\d.]/g, '');
                            const firstDot = sanitized.indexOf('.');
                            if (firstDot !== -1) {
                              const before = sanitized.slice(0, firstDot + 1);
                              const after = sanitized
                                .slice(firstDot + 1)
                                .replace(/\./g, '') // remove any additional dots
                                .slice(0, 2); // limit to two decimals
                              sanitized = before + after;
                            }
                            field.onChange(sanitized);
                          }}
                          // Prevents controlled / uncontrolled console warning message
                          value={field.value ?? ''}
                          disabled={field.disabled}
                          data-1p-ignore={false}
                        />
                      </FormControl>
                    </Stack>
                  </FormItem>

                  <FormMessage className="w-full text-right" />
                </Stack>
              );
            }}
          />
        </div>

        <div className="w-full">
          <FormTextField label="Tax ID" inputName="taxId" placeholder="Enter tax ID" isOptional={true} />
        </div>
      </Stack>
    </Stack>
  );
};
